export default __webpack_public_path__ + "static/dashboard-1a1f4403ed629c827445f6cf08a9e9aa.svg";